import { render, staticRenderFns } from "./delegateInfoForm.vue?vue&type=template&id=dc2edf88&scoped=true&"
import script from "./delegateInfoForm.vue?vue&type=script&lang=js&"
export * from "./delegateInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./delegateInfoForm.vue?vue&type=style&index=0&id=dc2edf88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2edf88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc2edf88')) {
      api.createRecord('dc2edf88', component.options)
    } else {
      api.reload('dc2edf88', component.options)
    }
    module.hot.accept("./delegateInfoForm.vue?vue&type=template&id=dc2edf88&scoped=true&", function () {
      api.rerender('dc2edf88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/NavbarMenu/components/SettingAndTools/delegateInfoForm.vue"
export default component.exports